var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.714,
    height: 20,
    viewBox: "0 0 25.714 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_id-card",
    "data-name": "solid id-card",
    d: "M23.571,32H2.143A2.143,2.143,0,0,0,0,34.143v.714H25.714v-.714A2.143,2.143,0,0,0,23.571,32ZM0,49.857A2.143,2.143,0,0,0,2.143,52H23.571a2.143,2.143,0,0,0,2.143-2.143V36.286H0ZM15.714,39.5a.358.358,0,0,1,.357-.357H22.5a.358.358,0,0,1,.357.357v.714a.358.358,0,0,1-.357.357H16.071a.358.358,0,0,1-.357-.357Zm0,2.857A.358.358,0,0,1,16.071,42H22.5a.358.358,0,0,1,.357.357v.714a.358.358,0,0,1-.357.357H16.071a.358.358,0,0,1-.357-.357Zm0,2.857a.358.358,0,0,1,.357-.357H22.5a.358.358,0,0,1,.357.357v.714a.358.358,0,0,1-.357.357H16.071a.358.358,0,0,1-.357-.357ZM7.857,39.143A2.857,2.857,0,1,1,5,42,2.86,2.86,0,0,1,7.857,39.143ZM3,48.259a2.861,2.861,0,0,1,2.719-1.973H6.08a4.6,4.6,0,0,0,3.554,0H10a2.861,2.861,0,0,1,2.719,1.973.7.7,0,0,1-.7.884H3.692A.7.7,0,0,1,3,48.259Z",
    transform: "translate(0 -32)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersIcon);
export default __webpack_public_path__ + "static/media/customers-icon.17b66458ceae099e7ebf83490079c6d0.svg";
export { ForwardRef as ReactComponent };